// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11725":"8ec630e7","23484":"14d0d237","57086":"2d8b5aa7"}[chunkId] + ".chunk.css";
};